module.exports = __webpack_public_path__ + "img/icon_05.276cd90.png";